<template>
  <div class="loading">
    <p>
      Carregando
    </p>
  </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style scoped lang="sass">
@tailwind utilities

.loading
  @apply relative z-50 flex justify-center items-center font-sans text-5xl text-grey bg-white w-full h-screen
</style>
